/* eslint-disable react/jsx-pascal-case */
import React, { Component, useState } from 'react';
import { Col, Row, Label, Input, Button, FormText } from 'reactstrap';
import { Control, Form, Errors, actions } from 'react-redux-form';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { checkHtmlTagAutoComplete } from '../utils/htmlTagAutoComplete';
import { handleArithmeticInput } from '../utils/arithmeticEval';
import { selectImageTagOnDoubleClick } from '../utils/imagePasteResize';

class Data extends Component {
  constructor (props) {
    super(props);
    this.state = {
      inputDateFlag: '',
      inputPlaceFlag: '',
      inputPersonFlag: '',
      inputSubjectFlag: '',
      inputReasonFlag: '',
      inputConditionFlag: '',
      inputDataFlag: '',
      inputUnitFlag: '',
      hasMounted: false
    };
    this.clearAllBoxes = this.clearAllBoxes.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.clearBox = this.clearBox.bind(this);
    this.setInputDateFlag = this.setInputDateFlag.bind(this);
    this.setInputPlaceFlag = this.setInputPlaceFlag.bind(this);
    this.setInputPersonFlag = this.setInputPersonFlag.bind(this);
    this.setInputSubjectFlag = this.setInputSubjectFlag.bind(this);
    this.setInputReasonFlag = this.setInputReasonFlag.bind(this);
    this.setInputConditionFlag = this.setInputConditionFlag.bind(this);
    this.setInputDataFlag = this.setInputDataFlag.bind(this);
    this.setInputUnitFlag = this.setInputUnitFlag.bind(this);
    this.restoreFormData = this.restoreFormData.bind(this);
  }

  async componentDidMount () {
    console.log(
      'Component mounted, props.dispatch available:',
      !!this.props.dispatch
    );
    await this.restoreFormData();
    this.setState({ hasMounted: true });

    // Listen for row selection events to update X button visibility
    this._isMounted = true;
    this.handleRowSelected = (e) => {
      try {
        // Check if component is still mounted before updating state
        if (!this._isMounted) return;

        const { formData } = e.detail || {};
        if (formData) {
          this.setState({
            inputDateFlag: formData.date || '',
            inputPlaceFlag: formData.place || '',
            inputPersonFlag: formData.person || '',
            inputSubjectFlag: formData.subject || '',
            inputReasonFlag: formData.reason || '',
            inputConditionFlag: formData.condition || '',
            inputDataFlag: formData.data || '',
            inputUnitFlag: formData.unit || ''
          });
        }
      } catch (err) {
        console.error('Error in handleRowSelected:', err);
      }
    };
    window.addEventListener('dataFormRowSelected', this.handleRowSelected);
  }

  componentWillUnmount () {
    this._isMounted = false;
    if (this.handleRowSelected) {
      window.removeEventListener('dataFormRowSelected', this.handleRowSelected);
    }
  }

  async componentDidUpdate (prevProps, prevState) {
    // If the form was just reset, restore the data
    if (this.state.hasMounted && !this.restoringData) {
      const currentValues = this.getCurrentFormValues();
      const allEmpty = Object.values(currentValues).every(v => !v);
      const stateHasData = Object.values({
        date: this.state.inputDateFlag,
        place: this.state.inputPlaceFlag,
        person: this.state.inputPersonFlag,
        subject: this.state.inputSubjectFlag,
        reason: this.state.inputReasonFlag,
        condition: this.state.inputConditionFlag,
        data: this.state.inputDataFlag,
        unit: this.state.inputUnitFlag
      }).some(v => v);

      if (allEmpty && stateHasData) {
        await this.restoreFormData();
      }
    }
  }

  getCurrentFormValues () {
    return {
      date: document.getElementById('date')?.value || '',
      place: document.getElementById('place')?.value || '',
      person: document.getElementById('person')?.value || '',
      subject: document.getElementById('subject')?.value || '',
      reason: document.getElementById('reason')?.value || '',
      condition: document.getElementById('condition')?.value || '',
      data: document.getElementById('data')?.value || '',
      unit: document.getElementById('unit')?.value || ''
    };
  }

  async restoreFormData () {
    this.restoringData = true;
    try {
      const savedDataString = localStorage.getItem('dataForm');
      console.log('Storage result:', savedDataString);

      if (savedDataString) {
        const savedData = JSON.parse(savedDataString);
        console.log('Saved data:', savedData);

        this.setState({
          inputDateFlag: savedData.date || '',
          inputPlaceFlag: savedData.place || '',
          inputPersonFlag: savedData.person || '',
          inputSubjectFlag: savedData.subject || '',
          inputReasonFlag: savedData.reason || '',
          inputConditionFlag: savedData.condition || '',
          inputDataFlag: savedData.data || '',
          inputUnitFlag: savedData.unit || ''
        });

        // Wait for DOM to be ready then update Redux store
        setTimeout(() => {
          console.log('Attempting to restore form data...');

          // Use dispatch to update the redux-form model if available
          if (this.props.dispatch) {
            console.log('Using dispatch to update Redux store');
            this.props.dispatch(
              actions.change('input.date', savedData.date || '')
            );
            this.props.dispatch(
              actions.change('input.place', savedData.place || '')
            );
            this.props.dispatch(
              actions.change('input.person', savedData.person || '')
            );
            this.props.dispatch(
              actions.change('input.subject', savedData.subject || '')
            );
            this.props.dispatch(
              actions.change('input.reason', savedData.reason || '')
            );
            this.props.dispatch(
              actions.change('input.condition', savedData.condition || '')
            );
            this.props.dispatch(
              actions.change('input.data', savedData.data || '')
            );
            this.props.dispatch(
              actions.change('input.unit', savedData.unit || '')
            );
          } else {
            console.log('No dispatch available!');
          }

          // Also set values directly in DOM as backup
          const fields = [
            'date',
            'place',
            'person',
            'subject',
            'reason',
            'condition',
            'data',
            'unit'
          ];
          fields.forEach(field => {
            const element = document.getElementById(field);
            if (element && savedData[field]) {
              console.log(`Setting ${field} to:`, savedData[field]);
              element.value = savedData[field];

              // Trigger multiple events to ensure redux-form picks it up
              const events = ['input', 'change', 'blur'];
              events.forEach(eventType => {
                const event = new Event(eventType, { bubbles: true });
                element.dispatchEvent(event);
              });
            }
          });
          this.restoringData = false;
          console.log('Form restoration complete');
        }, 200);
      } else {
        console.log('No saved data found in storage');
        this.restoringData = false;
      }
    } catch (error) {
      console.log('Error loading from storage:', error);
      this.restoringData = false;
    }
  }

  async saveToStorage () {
    const formData = {
      date: this.state.inputDateFlag,
      place: this.state.inputPlaceFlag,
      person: this.state.inputPersonFlag,
      subject: this.state.inputSubjectFlag,
      reason: this.state.inputReasonFlag,
      condition: this.state.inputConditionFlag,
      data: this.state.inputDataFlag,
      unit: this.state.inputUnitFlag
    };

    try {
      localStorage.setItem('dataForm', JSON.stringify(formData));
      console.log('Saved to localStorage:', formData);
    } catch (error) {
      console.error('Error saving to storage:', error);
    }
  }

  setInputDateFlag (flag) {
    this.setState({ inputDateFlag: flag }, () => this.saveToStorage());
  }

  setInputPlaceFlag (flag) {
    this.setState({ inputPlaceFlag: flag }, () => this.saveToStorage());
  }

  setInputPersonFlag (flag) {
    this.setState({ inputPersonFlag: flag }, () => this.saveToStorage());
  }

  setInputSubjectFlag (flag) {
    this.setState({ inputSubjectFlag: flag }, () => this.saveToStorage());
  }

  setInputReasonFlag (flag) {
    this.setState({ inputReasonFlag: flag }, () => this.saveToStorage());
  }

  setInputConditionFlag (flag) {
    this.setState({ inputConditionFlag: flag }, () => this.saveToStorage());
  }

  // Handle HTML tag auto-completion for reason/condition fields
  handleTagAutoComplete (e, setFlagMethod) {
    const textarea = e.target;
    const value = textarea.value;
    const cursorPos = textarea.selectionStart;

    // Set the flag first
    setFlagMethod(value);

    // Check for arithmetic evaluation (e.g. "1+1=" -> "2")
    handleArithmeticInput(textarea, value, (newVal) => {
      textarea.value = newVal;
      const inputEvent = new Event('input', { bubbles: true });
      textarea.dispatchEvent(inputEvent);
      setFlagMethod(newVal);
    });

    // Check for auto-completion
    const result = checkHtmlTagAutoComplete(value, cursorPos);
    if (result) {
      // Update the textarea value directly
      textarea.value = result.newValue;
      // Trigger change event for react-redux-form
      const event = new Event('input', { bubbles: true });
      textarea.dispatchEvent(event);
      // Set cursor position
      setTimeout(() => {
        textarea.selectionStart = result.cursorPos;
        textarea.selectionEnd = result.cursorPos;
        textarea.focus();
      }, 0);
      // Update flag with new value
      setFlagMethod(result.newValue);
    }
  }

  setInputDataFlag (flag) {
    this.setState({ inputDataFlag: flag }, () => this.saveToStorage());
  }

  setInputUnitFlag (flag) {
    this.setState({ inputUnitFlag: flag }, () => this.saveToStorage());
  }

  clearBox (id) {
    document.getElementById(id).value = '';
  }

  async clearAllBoxes () {
    this.setState({
      inputDateFlag: '',
      inputPlaceFlag: '',
      inputPersonFlag: '',
      inputSubjectFlag: '',
      inputReasonFlag: '',
      inputConditionFlag: '',
      inputDataFlag: '',
      inputUnitFlag: ''
    });

    try {
      localStorage.removeItem('dataForm');
      console.log('Cleared localStorage');
    } catch (error) {
      console.error('Error clearing storage:', error);
    }

    this.props.resetInputForm();
  }

  handleSubmit = value => {
    this.props.postInput(
      value.date,
      value.place,
      value.person,
      value.subject,
      value.reason,
      value.condition,
      value.data,
      value.unit
    );

    // Clear localStorage after submission
    try {
      localStorage.removeItem('dataForm');
    } catch (error) {
      console.error('Error clearing localStorage:', error);
    }

    // Clear the state flags
    this.setState({
      inputDateFlag: '',
      inputPlaceFlag: '',
      inputPersonFlag: '',
      inputSubjectFlag: '',
      inputReasonFlag: '',
      inputConditionFlag: '',
      inputDataFlag: '',
      inputUnitFlag: ''
    });

    // Reset the redux-form
    this.props.resetInputForm();
  };

  render () {
    const TooltipForDate = props => (
      <Tooltip id='button-tooltip' {...props}>
        if none, present time set
      </Tooltip>
    );
    const TooltipForPlace = props => (
      <Tooltip id='button-tooltip' {...props}>
        Converts HTML to link.
      </Tooltip>
    );
    const TooltipForData = props => (
      <Tooltip id='button-tooltip' {...props}>
        Converts HTML to link. Ignores delimiters.
      </Tooltip>
    );

    // Floating label styles
    const floatingLabelContainerStyle = {
      position: 'relative',
      marginBottom: '16px'
    };

    const floatingLabelStyle = (hasValue) => ({
      position: 'absolute',
      left: '12px',
      top: hasValue ? '6px' : '50%',
      transform: hasValue ? 'none' : 'translateY(-50%)',
      fontSize: hasValue ? '10px' : '14px',
      fontWeight: hasValue ? '500' : '400',
      textTransform: hasValue ? 'uppercase' : 'none',
      color: hasValue ? '#666' : '#999',
      pointerEvents: 'none',
      transition: 'all 0.2s ease',
      zIndex: 1,
      backgroundColor: hasValue ? '#fff' : 'transparent',
      padding: hasValue ? '0 4px' : '0'
    });

    const floatingInputStyle = (hasValue) => ({
      paddingTop: hasValue ? '22px' : '12px',
      paddingBottom: '8px',
      paddingRight: '35px',
      height: 'auto',
      minHeight: '48px',
      transition: 'all 0.2s ease'
    });

    const floatingTextareaStyle = (hasValue) => ({
      paddingTop: hasValue ? '22px' : '12px',
      paddingBottom: '8px',
      minHeight: '80px',
      transition: 'all 0.2s ease'
    });

    return (
      <div className='container main'>
        <style>{`
          .floating-input:focus + .floating-label,
          .floating-input:not(:placeholder-shown) + .floating-label {
            top: 6px !important;
            transform: none !important;
            font-size: 10px !important;
            font-weight: 500 !important;
            text-transform: uppercase !important;
            color: #666 !important;
            background-color: #fff !important;
            padding: 0 4px !important;
          }
          .floating-input:focus {
            padding-top: 22px !important;
          }
          .floating-input::placeholder {
            color: transparent;
          }
          .floating-input:focus::placeholder {
            color: #bbb;
          }
        `}</style>
        <div className='row align-items-center mb-3'>
          <div className='col'>
            <h1 style={{ fontWeight: 500, margin: 0, display: 'inline' }}>Data</h1>
            {this.props.inputCount !== undefined && (
              <span style={{
                fontSize: '13px',
                color: '#888',
                marginLeft: '12px',
                fontWeight: 400
              }}>
                {this.props.inputCount} items
              </span>
            )}
          </div>
        </div>
        <p style={{ color: '#888', fontSize: '14px', marginBottom: '24px' }}>
          Take any data you want to collect, analyze and know more.
        </p>
        <Form model='input' onSubmit={value => this.handleSubmit(value)}>
          <div style={floatingLabelContainerStyle}>
            <OverlayTrigger
              placement='top'
              delay={{ show: 250, hide: 400 }}
              overlay={TooltipForDate}
            >
              <div style={{ position: 'relative' }}>
                <Control.text
                  model='.date'
                  id='date'
                  name='date'
                  placeholder='2022-1-1'
                  className='form-control floating-input'
                  style={floatingInputStyle(this.state.inputDateFlag)}
                  onChange={e => this.setInputDateFlag(e.target.value)}
                />
                <label htmlFor='date' className='floating-label' style={floatingLabelStyle(this.state.inputDateFlag)}>
                  Date
                </label>
                {this.state.inputDateFlag && (
                  <button
                    type='button'
                    onClick={() => {
                      this.setInputDateFlag('');
                      document.getElementById('date').value = '';
                      if (this.props.dispatch) {
                        this.props.dispatch(actions.change('input.date', ''));
                      }
                      const event = new Event('change', { bubbles: true });
                      document.getElementById('date').dispatchEvent(event);
                    }}
                    style={{
                      position: 'absolute',
                      top: '50%',
                      right: '10px',
                      transform: 'translateY(-50%)',
                      backgroundColor: 'transparent',
                      border: 'none',
                      color: '#ccc',
                      cursor: 'pointer',
                      fontSize: '16px'
                    }}
                  >
                    ×
                  </button>
                )}
              </div>
            </OverlayTrigger>
          </div>
          <div style={floatingLabelContainerStyle}>
            <OverlayTrigger
              placement='top'
              delay={{ show: 250, hide: 400 }}
              overlay={TooltipForPlace}
            >
              <div style={{ position: 'relative' }}>
                <Control.text
                  model='.place'
                  id='place'
                  name='place'
                  placeholder='where?'
                  className='form-control floating-input'
                  style={floatingInputStyle(this.state.inputPlaceFlag)}
                  onChange={e => this.setInputPlaceFlag(e.target.value)}
                />
                <label htmlFor='place' className='floating-label' style={floatingLabelStyle(this.state.inputPlaceFlag)}>
                  Place
                </label>
                {this.state.inputPlaceFlag && (
                  <button
                    type='button'
                    onClick={() => {
                      this.setInputPlaceFlag('');
                      document.getElementById('place').value = '';
                      if (this.props.dispatch) {
                        this.props.dispatch(actions.change('input.place', ''));
                      }
                      const event = new Event('change', { bubbles: true });
                      document.getElementById('place').dispatchEvent(event);
                    }}
                    style={{
                      position: 'absolute',
                      top: '50%',
                      right: '10px',
                      transform: 'translateY(-50%)',
                      backgroundColor: 'transparent',
                      border: 'none',
                      color: '#ccc',
                      cursor: 'pointer',
                      fontSize: '16px'
                    }}
                  >
                    ×
                  </button>
                )}
              </div>
            </OverlayTrigger>
          </div>
          <div style={floatingLabelContainerStyle}>
            <div style={{ position: 'relative' }}>
              <Control.text
                model='.person'
                id='person'
                name='person'
                placeholder='who?'
                className='form-control floating-input'
                style={floatingInputStyle(this.state.inputPersonFlag)}
                onChange={e => this.setInputPersonFlag(e.target.value)}
              />
              <label htmlFor='person' className='floating-label' style={floatingLabelStyle(this.state.inputPersonFlag)}>
                Person
              </label>
              {this.state.inputPersonFlag && (
                <button
                  type='button'
                  onClick={() => {
                    this.setInputPersonFlag('');
                    document.getElementById('person').value = '';
                    if (this.props.dispatch) {
                      this.props.dispatch(actions.change('input.person', ''));
                    }
                    const event = new Event('change', { bubbles: true });
                    document.getElementById('person').dispatchEvent(event);
                  }}
                  style={{
                    position: 'absolute',
                    top: '50%',
                    right: '10px',
                    transform: 'translateY(-50%)',
                    backgroundColor: 'transparent',
                    border: 'none',
                    color: '#ccc',
                    cursor: 'pointer',
                    fontSize: '16px'
                  }}
                >
                  ×
                </button>
              )}
            </div>
          </div>
          <div style={floatingLabelContainerStyle}>
            <div style={{ position: 'relative' }}>
              <Control.text
                model='.subject'
                id='subject'
                name='subject'
                placeholder='what?'
                className='form-control floating-input'
                style={floatingInputStyle(this.state.inputSubjectFlag)}
                onChange={e => this.setInputSubjectFlag(e.target.value)}
              />
              <label htmlFor='subject' className='floating-label' style={floatingLabelStyle(this.state.inputSubjectFlag)}>
                Subject
              </label>
              {this.state.inputSubjectFlag && (
                <button
                  type='button'
                  onClick={() => {
                    this.setInputSubjectFlag('');
                    document.getElementById('subject').value = '';
                    if (this.props.dispatch) {
                      this.props.dispatch(actions.change('input.subject', ''));
                    }
                    const event = new Event('change', { bubbles: true });
                    document.getElementById('subject').dispatchEvent(event);
                  }}
                  style={{
                    position: 'absolute',
                    top: '50%',
                    right: '10px',
                    transform: 'translateY(-50%)',
                    backgroundColor: 'transparent',
                    border: 'none',
                    color: '#ccc',
                    cursor: 'pointer',
                    fontSize: '16px'
                  }}
                >
                  ×
                </button>
              )}
            </div>
          </div>
          <div style={floatingLabelContainerStyle}>
            <div style={{ position: 'relative' }}>
              <Control.textarea
                model='.reason'
                id='reason'
                name='reason'
                placeholder='why?'
                className='form-control floating-input'
                style={floatingTextareaStyle(this.state.inputReasonFlag)}
                onChange={e => this.handleTagAutoComplete(e, this.setInputReasonFlag.bind(this))}
                onDoubleClick={selectImageTagOnDoubleClick}
              />
              <label htmlFor='reason' className='floating-label' style={{
                ...floatingLabelStyle(this.state.inputReasonFlag),
                top: this.state.inputReasonFlag ? '6px' : '16px',
                transform: 'none'
              }}>
                Reason
              </label>
            </div>
          </div>
          <div style={floatingLabelContainerStyle}>
            <div style={{ position: 'relative' }}>
              <Control.textarea
                model='.condition'
                type='text'
                id='condition'
                name='condition'
                placeholder='how?'
                className='form-control floating-input'
                style={floatingTextareaStyle(this.state.inputConditionFlag)}
                onChange={e => this.handleTagAutoComplete(e, this.setInputConditionFlag.bind(this))}
                onDoubleClick={selectImageTagOnDoubleClick}
              />
              <label htmlFor='condition' className='floating-label' style={{
                ...floatingLabelStyle(this.state.inputConditionFlag),
                top: this.state.inputConditionFlag ? '6px' : '16px',
                transform: 'none'
              }}>
                Condition
              </label>
            </div>
          </div>
          <Row style={{ marginBottom: '16px' }}>
            <Col xs={6}>
              <div style={{ ...floatingLabelContainerStyle, marginBottom: 0 }}>
                <OverlayTrigger
                  placement='top'
                  delay={{ show: 250, hide: 400 }}
                  overlay={TooltipForData}
                >
                  <div style={{ position: 'relative' }}>
                    <Control.text
                      model='.data'
                      id='data'
                      name='data'
                      placeholder='12.3'
                      className='form-control floating-input'
                      style={floatingInputStyle(this.state.inputDataFlag)}
                      onChange={e => this.setInputDataFlag(e.target.value)}
                    />
                    <label htmlFor='data' className='floating-label' style={floatingLabelStyle(this.state.inputDataFlag)}>
                      Data
                    </label>
                    {this.state.inputDataFlag && (
                      <button
                        type='button'
                        onClick={() => {
                          this.setInputDataFlag('');
                          document.getElementById('data').value = '';
                          if (this.props.dispatch) {
                            this.props.dispatch(actions.change('input.data', ''));
                          }
                          const event = new Event('change', { bubbles: true });
                          document.getElementById('data').dispatchEvent(event);
                        }}
                        style={{
                          position: 'absolute',
                          top: '50%',
                          right: '10px',
                          transform: 'translateY(-50%)',
                          backgroundColor: 'transparent',
                          border: 'none',
                          color: '#ccc',
                          cursor: 'pointer',
                          fontSize: '16px'
                        }}
                      >
                        ×
                      </button>
                    )}
                  </div>
                </OverlayTrigger>
              </div>
            </Col>
            <Col xs={6}>
              <div style={{ ...floatingLabelContainerStyle, marginBottom: 0 }}>
                <div style={{ position: 'relative' }}>
                  <Control.text
                    model='.unit'
                    id='unit'
                    name='unit'
                    placeholder='g'
                    className='form-control floating-input'
                    style={floatingInputStyle(this.state.inputUnitFlag)}
                    onChange={e => this.setInputUnitFlag(e.target.value)}
                  />
                  <label htmlFor='unit' className='floating-label' style={floatingLabelStyle(this.state.inputUnitFlag)}>
                    Unit
                  </label>
                  {this.state.inputUnitFlag && (
                    <button
                      type='button'
                      onClick={() => {
                        this.setInputUnitFlag('');
                        document.getElementById('unit').value = '';
                        if (this.props.dispatch) {
                          this.props.dispatch(actions.change('input.unit', ''));
                        }
                        const event = new Event('change', { bubbles: true });
                        document.getElementById('unit').dispatchEvent(event);
                      }}
                      style={{
                        position: 'absolute',
                        top: '50%',
                        right: '10px',
                        transform: 'translateY(-50%)',
                        backgroundColor: 'transparent',
                        border: 'none',
                        color: '#ccc',
                        cursor: 'pointer',
                        fontSize: '16px'
                      }}
                    >
                      ×
                    </button>
                  )}
                </div>
              </div>
            </Col>
          </Row>
          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '12px',
            marginTop: '32px',
            paddingTop: '16px',
            borderTop: '1px solid #eee'
          }}>
            <button
              type='button'
              onClick={this.clearAllBoxes}
              style={{
                backgroundColor: 'transparent',
                border: '0.5px solid #ccc',
                color: '#666',
                fontWeight: 500,
                padding: '8px 24px',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '14px',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={e => {
                e.target.style.backgroundColor = '#f5f5f5';
                e.target.style.borderColor = '#999';
              }}
              onMouseLeave={e => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.borderColor = '#ccc';
              }}
            >
              Clear
            </button>
            <button
              type='submit'
              disabled={this.props.isUpdating}
              style={{
                backgroundColor: '#185FA5',
                border: 'none',
                color: '#fff',
                fontWeight: 500,
                padding: '8px 24px',
                borderRadius: '8px',
                cursor: this.props.isUpdating ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                opacity: this.props.isUpdating ? 0.6 : 1,
                transition: 'all 0.2s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
              }}
              onMouseEnter={e => {
                if (!this.props.isUpdating) {
                  e.target.style.backgroundColor = '#134a82';
                }
              }}
              onMouseLeave={e => {
                e.target.style.backgroundColor = '#185FA5';
              }}
            >
              <span style={{ fontSize: '16px', fontWeight: 'bold' }}>+</span>
              Submit
            </button>
          </div>
        </Form>
      </div>
    );
  }
}

export default Data;
